import React, { memo, useCallback, useRef, useState } from 'react';
import './WebCard.less';

interface WebCardProps {
  href?: string;
  children?: React.ReactNode;
}

const WebCard: React.FC<WebCardProps> = ({ href, children }) => {
  const [loadState, setLoadState] = useState<'loading' | 'loaded' | 'error'>('loading');
  const iframeRef = useRef<HTMLIFrameElement>(null);

  const handleOpen = useCallback(() => {
    if (!href) return;
    window.open(href, '_blank', 'noreferrer');
  }, [href]);

  const handleFaviconError = useCallback((event: React.SyntheticEvent<HTMLImageElement>) => {
    event.currentTarget.style.display = 'none';
  }, []);

  const handleIframeLoad = useCallback((event: React.SyntheticEvent<HTMLIFrameElement>) => {
    event.preventDefault();
    event.stopPropagation();
    setLoadState('loaded');
  }, []);

  const handleIframeError = useCallback((event: React.SyntheticEvent<HTMLIFrameElement>) => {
    event.preventDefault();
    event.stopPropagation();
    setLoadState('error');
  }, []);

  if (!href) return <>{children}</>;

  let hostname = '';
  try {
    hostname = new URL(href).hostname;
  } catch {
    hostname = href;
  }

  const label = children
    ? (typeof children === 'string' ? children : undefined)
    : undefined;

  return (
    <div className="web-card">
      <div className="web-card__header">
        <span className="web-card__favicon">
          <img
            src={`https://www.google.com/s2/favicons?sz=16&domain=${hostname}`}
            alt=""
            width={14}
            height={14}
            onError={handleFaviconError}
          />
        </span>
        <span className="web-card__hostname">{hostname}</span>
        {/* <span className="web-card__url" title={href}>{label || href}</span> */}
      </div>

      <div className="web-card__iframe-wrap">
        {loadState === 'loading' && (
          <div className="web-card__placeholder web-card__placeholder--loading">
            加载中…
          </div>
        )}
        {loadState === 'error' && (
          <div className="web-card__placeholder web-card__placeholder--error">
            页面无法预览（可能已设置禁止嵌入）
          </div>
        )}
        <iframe
          ref={iframeRef}
          className={`web-card__iframe${loadState === 'loaded' ? ' web-card__iframe--visible' : ''}`}
          src={href}
          sandbox="allow-scripts"
          referrerPolicy="no-referrer"
          allow="clipboard-read 'none'; clipboard-write 'none'; camera 'none'; microphone 'none'; geolocation 'none'; fullscreen 'none'"
          onLoad={handleIframeLoad}
          onError={handleIframeError}
          title={label || href}
          loading="lazy"
        />
      </div>

      <div className="web-card__footer">
        <span className="web-card__footer-url" title={href}>{href}</span>
        <button
          type="button"
          className="web-card__open-btn"
          onClick={handleOpen}
        >
          在浏览器中打开 ↗
        </button>
      </div>
    </div>
  );
};

export default memo(WebCard);
